import React, { useState } from 'react';
import { useSnackbar } from 'notistack';

import { Collapse, TableRow, TableCell, Button, TextField } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

import { getApi } from '../../api';
import { useStyles } from './useStyles';
import { vehicle_type, vehicle_status } from '../../utils/constants';

const RowVehicle = ({ row, index, setVehicles }) => {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [newVehicle, setNewVehicle] = useState({
    id: row.id,
    description: row.description,
    license_plate: row.license_plate,
    capacity: row.capacity,
    vehicle_type: row.vehicle_type,
    status: row.status,
  });

  const handleVehicleChange = name => event => {
    setNewVehicle({
      ...newVehicle,
      [name]: event.target.value,
    });
  };

  const handleSubmitVehicle = async () => {
    // make insert
    try {
      const vehicle = newVehicle;
      const response = await getApi().put(`/vehicles/${row.id}`, {
        vehicle,
      });

      //* *200 authorized*/
      if (response !== undefined && response.status === 200) {
        setVehicles({ isLoading: true });
        handleRowClick('', index);
        enqueueSnackbar('Vehículo actualizado correctamente', {
          variant: 'success',
        });
      }
    } catch (error) {
      let errorMessage = [];

      if (error.status === 400) {
        if (error.data.errors.scheduled_services) {
          error.data.errors.scheduled_services.map(item => errorMessage.push(item));
        }

        if (error.data.errors.capacity) {
          error.data.errors.capacity.map(item => errorMessage.push(item));
        }
      }

      enqueueSnackbar(errorMessage.toString(), {
        variant: 'error',
      });
    }
  };

  const handleRowClick = (event, index) => {
    if (selectedIndex === index) {
      setSelectedIndex(null);
    } else {
      setSelectedIndex(index);
    }
  };

  const handleDeleteVehicle = async value => {
    try {
      const response = await getApi().delete(`/vehicles/${value}`, { data: {} });
      if (response && response.status === 204) {
        enqueueSnackbar('Vehículo eliminado correctamente', {
          variant: 'success',
        });
        setVehicles({ isLoading: true });
      }
    } catch (error) {
      enqueueSnackbar('No se pudo eliminar el vehículo porque tiene solicitudes asociadas', {
        variant: 'error',
      });
    }
  };
  return (
    <>
      <TableRow
        key={row.id}
        hover
        style={{ cursor: 'pointer' }}
        onClick={event => handleRowClick(event, index)}
      >
        <TableCell component="th" scope="row">
          {row.license_plate}
        </TableCell>
        <TableCell align="center">
          {vehicle_type.find(x => x.value === row.vehicle_type).label}
        </TableCell>
        <TableCell align="center">{row.capacity}</TableCell>
        <TableCell align="center">{row.status}</TableCell>
        <TableCell align="left">{row.description}</TableCell>
        <TableCell>
          <Button
            variant="contained"
            className={classes.button}
            value={row.id}
            color="secondary"
            onClick={e => handleDeleteVehicle(e.currentTarget.value)}
            startIcon={<DeleteIcon />}
          >
            Eliminar
          </Button>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={12}>
          <Collapse in={selectedIndex === index} timeout="auto" unmountOnExit>
            <div className={classes.vehicleDetail}>
              <TextField
                id="outlined-full-width"
                label="Placa"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                value={newVehicle.license_plate}
                onChange={handleVehicleChange('license_plate')}
              />
              <TextField
                id="outlined-select-currency-native"
                select
                label="Tipo"
                value={newVehicle.vehicle_type}
                onChange={handleVehicleChange('vehicle_type')}
                SelectProps={{
                  native: true,
                }}
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              >
                {vehicle_type.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
              <TextField
                id="outlined-full-width"
                label="Capacidad"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                value={newVehicle.capacity}
                onChange={handleVehicleChange('capacity')}
              />
              <TextField
                id="outlined-select-currency-native"
                select
                label="Estado"
                value={newVehicle.status}
                onChange={handleVehicleChange('status')}
                SelectProps={{
                  native: true,
                }}
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
              >
                {vehicle_status.map(option => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </TextField>
              <TextField
                id="outlined-full-width"
                label="Observaciones"
                fullWidth
                margin="normal"
                variant="outlined"
                InputLabelProps={{
                  shrink: true,
                }}
                value={newVehicle.description}
                onChange={handleVehicleChange('description')}
              />
              <br />
              <Button
                variant="contained"
                className={classes.button}
                color="primary"
                onClick={() => {
                  handleSubmitVehicle();
                }}
                startIcon={<CheckCircleOutlineIcon />}
              >
                Guardar
              </Button>
            </div>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
};

export default RowVehicle;
